module.exports = __webpack_public_path__ + "static/media/licenta36.7110dd4d.png";